import * as React from 'react';
import Page from '../containers/Page';

export default () => (
  <Page title="Logbook">
      logbook
    </Page>
)